import * as Sentry from "@sentry/vue"

export function initSentry(app, router) {
  const dsn = process.env.VUE_APP_SENTRY_DSN
  if (!dsn) {
    return
  }

  Sentry.init({
    app,
    dsn,
    environment: process.env.VUE_APP_SENTRY_ENVIRONMENT || "production",
    integrations: [Sentry.browserTracingIntegration({ router })],
    tracesSampleRate: 0.2,
    initialScope: {
      tags: { repository: "gs-webex-sys" },
    },
  })
}
